jQuery(document).ready(function($) {

	let select = $('select.product-category-select');

	if ( select.length ) {
		select.selectWoo({
			width     : '100%',
			allowClear: false
		});
	}
});